module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.ttf?8db7e5c067ed97acc8857768671254d5";